module.exports = (s) => s.toUpperCase();
